export default __webpack_public_path__ + "static/media/infoCircle.b0cc32ab.svg";